import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, useParams, useLocation } from 'react-router-dom';
import Sidebar from '../Sidebar';
import ChatContainer from '../ChatContainer';
import { AppContainer } from './styles.js';
import '@fortawesome/fontawesome-free/css/all.min.css';
import { fetchInterviews } from '../../api/chat.js';
import PublicChatContainer from '../PublicChatContainer/index.js';

// Componente de Boas-vindas
const Home = () => (
  <div style={{ textAlign: 'center', marginTop: '20%' }}>
    <h1>Bem-vindo ao Sistema de Entrevistas</h1>
    <p>Selecione uma entrevista para começar.</p>
  </div>
);

const InterviewContainer = ({ interviews, talent, setTalent, setInterviews, onNewInterview }) => {
  const location = useLocation();
  const { talent_uuid } = useParams();
  const searchParams = new URLSearchParams(location.search);
  const app_id = searchParams.get('app_id');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getInterviews = async () => {
      try {
        const data = await fetchInterviews(talent_uuid);
        setTalent(talent);
        setInterviews(data);
      } catch (error) {
        console.error('Error fetching candidate data:', error);
      } finally {
        setLoading(false);
      }
    };

    getInterviews();
  }, [talent_uuid, app_id, setTalent, setInterviews]);

  return <ChatContainer interviews={interviews} onNewInterview={onNewInterview} />;
};

const PublicInterviewContainer = () => {
  const location = useLocation();
  const { interview_uuid } = useParams();
  const searchParams = new URLSearchParams(location.search);
  const talent_uuid = searchParams.get('talent');
  const [loading, setLoading] = useState(true);

  return <PublicChatContainer 
            interview_uuid={interview_uuid} 
            talent_uuid={talent_uuid} 
          />;
};

const AppContent = ({ interviews, talent, setTalent, setInterviews }) => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const currentInterviewId = searchParams.get('app_id');
  const token = searchParams.get('token');

  useEffect(() => {
    if (token) {
      localStorage.setItem('token', token);
    } else {
      if(!window.location.href.includes('public') ){
        window.location.href = 'https://recrutei.com.br';
      }
    }
  }, [token]);

  const handleNewInterview = (vacancyTitle, companyName, talentUuid, applicationId) => {
    if (interviews && !interviews.find(interview => Number(interview.application_id) === Number(applicationId))) {
      const newInterview = {
        application_id: applicationId,
        company_name: companyName,
        vacancy_title: vacancyTitle,
        talent_uuid: talentUuid
      };

      setInterviews([newInterview, ...interviews]);
    }
  };

  useEffect(() => {
    if (interviews && currentInterviewId) {
      const currentInterview = interviews.find(interview => interview.application_id === currentInterviewId);
      
      if (!currentInterview) {
        // Os valores padrão não são mais necessários, pois serão definidos pelo ChatContainer
      }
    }
  }, [currentInterviewId, interviews, setInterviews]);

  const showSidebar = !location.pathname.startsWith('/public/interview');

  return (
    <AppContainer>
      {showSidebar && <Sidebar interviews={interviews} currentInterviewId={currentInterviewId} />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route 
          path="/interview/:talent_uuid" 
          element={<InterviewContainer 
            interviews={interviews} 
            talent={talent} 
            setTalent={setTalent} 
            setInterviews={setInterviews} 
            onNewInterview={handleNewInterview}
          />} 
        />
        <Route 
          path="/public/interview/:interview_uuid" 
          element={<PublicInterviewContainer />} 
        />
      </Routes>
    </AppContainer>
  );
};

function App() {
  const [interviews, setInterviews] = useState(null);
  const [talent, setTalent] = useState(null);

  return (
    <Router>
      <AppContent 
        interviews={interviews} 
        talent={talent} 
        setTalent={setTalent} 
        setInterviews={setInterviews} 
      />
    </Router>
  );
}

export default App;
